import CustomFieldFormConfig from "./form";
import { CustomFieldFormData } from "@/formTypes/CustomFieldFormDataType";
import GenericForm from "../GenericForm";
import { CustomFieldsTemplateIds } from "@pages/user/CustomFields";
import { useEffect, useState } from "react";
import { CustomFieldApi, CustomFieldDataType } from "@/api/CustomFieldsApi";

type CustomFieldFormProps = {
  templateId: CustomFieldsTemplateIds;
  formId: string,
  saveRedirectUrl: string
}

const CustomFieldForm = (props: CustomFieldFormProps) => {
  const { templateId } = props;
  const [customField, setCustomField] = useState<CustomFieldDataType>({});

  useEffect(() => {
    if (templateId) {
      const run = async () => {
        const data = await CustomFieldApi.fetchByDocumentType(templateId);
        setCustomField(data);
      }
      run()
    }
  }, [templateId]);



  return (
    <GenericForm<CustomFieldFormData, CustomFieldDataType>
      id={customField?.id}
      defaultData={{ document_key: templateId }}
      formId={props.formId}
      saveRedirectUrl={props.saveRedirectUrl}
      formConfig={CustomFieldFormConfig}
      getById={(...arg) => CustomFieldApi.get(...arg)}
      createFn={(...arg) => CustomFieldApi.create(...arg)}
      updateFn={(...arg) => CustomFieldApi.update(...arg)}
      successMessage="La informacion personalizada ha sido almacenada correctamente"
      errorMessage="No fue posible almacenar la información personalizada"
    />
  )
}

export default CustomFieldForm;